<!-- header: bottom-start — titulek sedí u levé hrany obsahu a bottom-end by širší panel
     roztáhl doleva přes sidebar (vypadá jako odtržené menu); list: bottom-end u pravého ⋮ -->
<gg-dropdown [class.list-context]="context === 'list'" [placement]="context === 'header' ? 'bottom-start' : 'bottom-end'">
  <!-- Header context: malý chevron -->
  @if (context === 'header') {
    <button class="btn-chevron-toggle"
    ggDropdownToggle type="button" [attr.aria-label]="'chat.actions.aria-label' | translate">
      @if (title) {
        <span class="card-heading-lg truncate min-w-0">{{ title }}</span>
      }
      <app-icon icon="app:expand" size="lg" />
    </button>
  }
  <!-- List context: dots icon -->
  @if (context === 'list') {
    <button class="btn btn-ghost btn-sm btn-circle"
      ggDropdownToggle type="button" [attr.aria-label]="'chat.actions.aria-label' | translate">
      <app-icon icon="app:more" size="sm" />
    </button>
  }

  <ng-template ggDropdownMenu>
    <div class="gg-popup min-w-44 py-1">
      <ul class="menu w-full">
        @if (!isStarred) {
          <li>
            <button class="gap-2" type="button" (click)="onActionClick('star')">
              <app-icon icon="app:favoriteOff" size="sm" />
              {{ 'chat.actions.star' | translate }}
            </button>
          </li>
        }
        @if (isStarred) {
          <li>
            <button class="gap-2" type="button" (click)="onActionClick('unstar')">
              <app-icon icon="app:favoriteOn" size="sm" />
              {{ 'chat.actions.unstar' | translate }}
            </button>
          </li>
        }
        <li>
          <button class="gap-2" type="button" (click)="onActionClick('rename')">
            <app-icon icon="app:edit" size="sm" />
            {{ 'chat.actions.rename' | translate }}
          </button>
        </li>
        <li>
          <button class="gap-2" type="button" (click)="onActionClick('export')">
            <app-icon icon="app:download" size="sm" />
            {{ 'chat.actions.export' | translate }}
          </button>
        </li>
      </ul>
      <div class="popup-separator"></div>
      <ul class="menu w-full">
        <li>
          <button class="gap-2 text-error" type="button" appConfirmDelete (confirmAction)="onActionClick('delete')">
            <app-icon icon="app:delete" size="sm" />
            {{ 'chat.actions.delete' | translate }}
          </button>
        </li>
      </ul>
    </div>
  </ng-template>
</gg-dropdown>
